import Workflows from './Workflows'

export default Workflows;